import React from "react";
import { Accordion } from "react-bootstrap";
import { trim, split, filter, map, get } from "lodash";
import { Typography } from "antd";
import { useSmartAssistStore } from "../store";
const { Title } = Typography;

const ProductRead = ({ targetVariantId }) => {

  const { saVariantProductReadMap, isCxUsedProductBefore } = useSmartAssistStore();

  const productRead = saVariantProductReadMap?.[targetVariantId] || null;

  return (
    productRead && (
      <div className="container mt-4 px-0">
        <Title level={5}>
          Product Read:
        </Title>
        <div className="card mb-4">
          <div className="card-body">
            <Accordion defaultActiveKey={!isCxUsedProductBefore && '0'}>
              {productRead?.map((read, index) => (
                <Accordion.Item eventKey={index.toString()} key={read.id || index}>
                  <Accordion.Header>
                    {read.heading || `Panel ${index + 1}`}
                  </Accordion.Header>
                  <Accordion.Body>
                    {get(read, 'content') ? (
                      map(
                        filter(split(read.content, '\n'), (line) => trim(line).length > 0),
                        (line, i) => <p key={i}>{line}</p>
                      )
                    ) : (
                      <p className="text-muted">No content provided.</p>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    )
  );
};


export default ProductRead;